export enum TipoEntidade {
  LOCAL_DE_TRABALHO = 'local_de_trabalho',
  EMPREGADO = 'empregado',
  PERFIL = 'perfil',
  GRUPO = 'grupo'
}

export type Ordenavel = "nome" | "ativo"
export type Ordem = "asc" | "desc"

export interface EntidadesAfetadas {
  ids: string[];
  tipo: TipoEntidade
}

export interface RegraDeAdiantamentoDoDecimoTerceiro {
  diaLimiteParaSolicitarAdiantamentoDoDecimoTerceiro: number;
  mesLimiteParaSolicitarAdiantamentoDoDecimoTerceiro: number;
  mesLimiteParaRequisitar: number;
}

export interface RegraDeFerias {
  id: string;
  nome: string;
  regraDeAdiantamentoDoDecimoTerceiro: RegraDeAdiantamentoDoDecimoTerceiro;
  permitePedirFeriasNoPeriodoAquisitivo: boolean;
  entidadesAfetadas: EntidadesAfetadas;
  ativo: boolean;
}

export interface IRespostaCriarRegraDeFerias {
  data: {
    mensagem: string
  }
}

export interface IRespostaEditarRegraDeFerias {
  data: {
    mensagem: string
  }
}

export interface IRequisicaoBuscarRegrasDeFerias {
  paginacao: {
    pagina: number;
    porPagina: number;
  };
  ordenarPor?: Ordenavel;
  ordem?: Ordem;
  nome?: string;
  ativo?: boolean;
  tipoDeEntidadeAfetada?: TipoEntidade;
}

export interface IRespostaBuscarRegrasDeFerias {
  data: {
    itens: RegraDeFerias[];
    pagina: number;
    porPagina: number;
    total: number;
  }
}

export interface IRespostaBuscarRegraDeFeriasPorId {
  data: RegraDeFerias | null;
}

export interface IRespostaExcluirRegraDeFerias {
  data: {
    mensagem: string;
  }
}
